<template>
  <div class="row">
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <div class="col-lg-2">
          <base-button type="primary" v-on:click="getReferenceNo()">
            + Request Job</base-button
          >
        </div>
        <div class="col-lg-2">
          <el-select
            placeholder="Select status"
            v-model="selects.status"
            @change="getData()"
            filterable
          >
            <el-option
              v-for="option in selects.statuses"
              class="select-info custom-option"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-lg-3 text-left">
          <div style="display: flex; flex-direction: row; height: 80%">
            <div
              style="width: 8px; height: 80%; background-color: #0baa00"
            ></div>
            &nbsp;
            <p style="margin: 10px; color: #A5A5A5">Completed</p>
            &nbsp;
            <div
              style="width: 8px; height: 80%; background-color: #ff9900"
            ></div>
            &nbsp;
            <p style="margin: 10px; color: #A5A5A5">Action Required</p>
          </div>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-2">
          <!-- <base-input> -->
          <el-input
            type="search"
            class="mb-3 search-input"
            prefix-icon="el-icon-search"
            placeholder="Search Job, Cust..."
            v-model="searchQuery"
            aria-controls="datatables"
          ></el-input>
          <!-- </base-input> -->
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div id="tableku" v-if="this.load == false">
              <el-table
                :data="queriedData"
                style="width: 100%; color: #A5A5A5"
                height="700"
                :header-cell-style="{
                  background: 'transparent',
                  color: 'black',
                }"
                class="custom-table"
              >
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="jobno"
                  label="REFERENCE NO"
                >
                  <div slot-scope="{ row }">
                    <p
                      class="job-no-title"
                      style="color: #358CCB"
                      @click="getJobPage(row)"
                    >
                      {{ row.jobno }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column
                  :min-width="200"
                  sortable
                  align="center"
                  prop="datecreated"
                  label="DATE CREATED"
                >
                <div slot-scope="{ row }">
                      {{ moment(row.datecreated).format(
                        "DD MMM YYYY"
                      ) }}</div>
              </el-table-column>
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="jobstatus"
                  label="JOB STATUS"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #0baa00"
                      v-if="
                        row.jobstatus == 'Completed' ||
                        row.jobstatus == 'Accepted'
                      "
                    >
                      {{ row.jobstatus }}
                    </p>
                    <p
                      style="color: #ff0000"
                      v-else-if="
                        row.jobstatus == 'Pending' ||
                        row.jobstatus == 'Disputed'
                      "
                    >
                      {{ row.jobstatus }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.jobstatus }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="quotation"
                  label="QUOTATION"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #ff0000"
                      v-if="row.quotation.toLowerCase() === 'pending'"
                    >
                      {{ row.quotation }}
                    </p>

                    <p
                      class="link"
                      @click="getReview(row)"
                      style="color: #ffa827"
                      v-else-if="
                        row.quotation.toLowerCase() === 'ready to review'
                      "
                    >
                      {{ row.quotation }}
                    </p>

                    <p
                      style="color: #0baa00"
                      v-else-if="row.quotation.toLowerCase() === 'completed'"
                    >
                      {{ row.quotation }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.quotation }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" sortable align="center" prop="collectiondate" label="COLLECTION DATE">
                  <div slot-scope="{ row }">
                      {{ moment(row.collectiondate).format(
                        "DD MMM YYYY"
                      ) }}</div>
                </el-table-column>
                <!-- <el-table-column
                  v-for="column in joblist"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :min-width="200"
                >
                </el-table-column> -->
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="wdr"
                  label="WDR"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #ff0000"
                      v-if="row.wdr.toLowerCase() === 'pending'"
                    >
                      {{ row.wdr }}
                    </p>
                    <p
                      style="color: #0baa00"
                      v-else-if="row.wdr.toLowerCase() === 'completed'"
                    >
                      {{ row.wdr }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.wdr }}
                    </p>
                  </div>
                </el-table-column>
                <!-- <el-table-column
                  :min-width="200"
                  align="center"
                  prop="labreport"
                  label="LAB REPORT"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #0baa00"
                      v-if="row.labreport.toLowerCase === 'complete'"
                    >
                      {{ row.labreport }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.labreport }}
                    </p>
                  </div>
                </el-table-column> -->
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="invoice"
                  label="INVOICE"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #ff0000"
                      v-if="row.invoice.toLowerCase() === 'pending'"
                    >
                      {{ row.invoice }}
                    </p>
                    <p
                      style="color: #0baa00"
                      v-else-if="row.invoice.toLowerCase() === 'completed'"
                    >
                      {{ row.invoice }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.invoice }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column
                  :min-width="200"
                  align="center"
                  prop="shipname"
                  label="SHIP NAME"
                >
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5">
                      {{ row.shipname }}
                    </p>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div class="d-flex justify-content-center spinner" v-if="load">
              <circle-8></circle-8>
            </div>
          </card>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <!-- <base-input> -->
            <el-select v-model="pagination.perPage" placeholder="Per page">
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- </base-input> -->
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";

export default {
  name: "VesselRequest",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      selectedFileName: "",
      allfilename: [],
      tableDatas: [],

      load: false,
      jobnum: "",
      jobno: [
        {
          prop: "jobno",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "collectiondate",
          label: "COLLECTION DATE",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],

        type: "",
        types: [
          { value: "00", label: "All" },
          { value: "01", label: "Waste" },
          { value: "02", label: "Product" },
        ],
        status: "",
        statuses: [],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30, 50],
        total: 0,
      },
    };
  },
  methods: {
    getStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/incoming/status").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].id,
            };
            this.selects.statuses.push(obj);
          }
        }
      });
    },
    camelCase(str) {
      if (str != "") {
        var splitStr = str.toLowerCase().split(" ");
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
      }
    },

    getReview(data) {
      this.jobnum = data.jobno;
      this.$router.push("/Vessel/Review/" + this.jobnum);
    },

    getJobPage(data) {
      console.log(data);
      this.jobnum = data.jobno;
      if (data.jobstatus.toUpperCase() == "DRAFT") {
        this.$router.push("/Vessel/RequestJob/" + this.jobnum + "/edit");
      } else {
        sessionStorage.setItem("datasubmitted", true);
        this.$router.push("/Vessel/RequestJob/" + this.jobnum + "/view");
      }
    },

    getReferenceNo() {
      this.$http.get(":10001/api/v1/incoming/generate").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("data here", response);

          this.referenceno = response.reference_no;
          this.wastejobid = response.waste_job_id;
          console.log("job num new", this.referenceno);

          // sessionStorage.setItem("job-num-id-land", this.wastejobid);
          sessionStorage.setItem("datasubmitted", false);
          this.$router.push("/Vessel/RequestJob/" + this.referenceno + "/add");
        }
      });
    },

    getData() {
      this.tableDatas = [];
      this.temp = [];
      this.load = true;

      this.$http
        .get(":10001/api/v1/incoming?status=" + this.selects.status)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                jobno: response[i].reference_no,
                datecreated: 
                // moment(
                  response[i].created_at
                // ).format(
                  // "DD-MM-YYYY"
                // )
                ,
                jobstatus: this.camelCase(response[i].waste_job_status_text),
                quotation: this.camelCase(response[i].quotation_status_text),
                collectiondate: 
                // moment(
                  response[i].arrival_eta
                // ).format(
                  // "DD-MM-YYYY"
                // )
                ,
                invoice: this.camelCase(response[i].invoice_status_text),
                shipname:
                  response[i].ship_name == ""
                    ? "-"
                    : this.camelCase(response[i].ship_name),
                wdr: this.camelCase(response[i].waste_disposal_status_text),
                labreport: this.camelCase(response[i].lab_report_status_text),
              };
              this.tableDatas.push(obj);
              this.temp.push(obj);
            }

            this.load = false;
          }
        });
    },
  },
  created() {
    this.getStatus();
    this.getData();
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter(
          (value) =>
            value.jobno.toLowerCase().includes(search.toLowerCase()) ||
            value.shipname.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["jobno"],
      threshold: 1.0,
    });
  },
};
</script>
<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.job-no-title {
  color: #358CCB;
  text-decoration: none;
}
.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.link {
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
